
var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){

   
 setInterval(function(){ 
   if($('span.sale.savings').eq(0).text().includes('save')){
     
var saved = $('span.sale.savings').eq(0).text();

saved = "-" + saved.split('save: ')[1].split(' (')[0];

$('span.sale.savings').eq(0).html(saved);
   }
}, 50);

  jQuery('.crc-buyNow').click(function(){
    var b = 0;
var timerb = setInterval(function(){
  if(jQuery('.shopify-payment-button__more-options').eq(0).length || b > 200) {
	 jQuery('.shopify-payment-button__more-options').eq(0).click();;
     clearInterval(timerb);
  }
b++;
}, 50);
  });
   
  sticky(); 
function sticky(){
var ur = window.location.href;
if(ur.includes('/product')){
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="crc-st-container" id="crc-st-containerID"> <div class="crc-st-container__outer"><div class="crc-product-cont"><div class="crc-product-name"></div><div class="crc-product-price"></div></div> <div class="crc-st-container__inner"> <div class="crc-select-container"> <div class="crc-st-select" id="st-select0"> <span>Color</span> <select> <option></option> </select> </div><div class="crc-st-select" id="st-select1"> <span>Type</span> <select> <option></option> </select> </div><div class="crc-st-select" id="st-select2"> <span>Type</span> <select> <option></option> </select> </div></div><div class="crc-st-item_column__button"><a class="crc-st-item__button" rel="nofollow">Buy Now</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('crc-st-container').length == 0){
  y[0].appendChild(sticky);
  
  
jQuery('.crc-product-name').html(jQuery('h1.product_name.title').eq(0).html());
  
 
function populateOptions(select, labels){
  var selected = labels.eq(0).prop('selectedIndex');
  labels = labels.eq(0).find('option');
  for(var i =0; i < labels.length; i++){
      var option = document.createElement('OPTION');
        
      
    
      var t = document.createTextNode(labels.eq(i).html());
      option.appendChild(t);
   	  option.id = i;
      select.appendChild(option);
    
    	if(i ==0){
          select.removeChild(select.firstElementChild);
          
          
        }
    
  }
  
  select.selectedIndex = selected;
}
  
  jQuery('.crc-st-item__button').click(function(){
   if(!jQuery('.crc-st-item__button').hasClass("crc-st-disabled")){
     
      jQuery('.crc-buyNow').eq(0).click();
      }
    
   
  });
  
 if(jQuery('.selector-wrapper').eq(0).length >= 1){
 
   jQuery('.crc-st-select span').eq(0).html(jQuery('.selector-wrapper').eq(0).find('label').eq(0).html());
  jQuery('#st-select0').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select0').getElementsByTagName('select')[0], jQuery('.selector-wrapper:eq(0) select'));
}
    
    
  
  if(jQuery('.selector-wrapper').eq(1).length >= 1){
    jQuery('.crc-st-select span').eq(1).html(jQuery('.selector-wrapper').eq(1).find('label').eq(0).html());
  jQuery('#st-select1').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select1').getElementsByTagName('select')[0], jQuery('.selector-wrapper:eq(1) select'));
}
   if(jQuery('.selector-wrapper').eq(2).length >= 1){
     jQuery('.crc-st-select span').eq(2).html(jQuery('.selector-wrapper').eq(2).find('label').eq(0).html());
  jQuery('#st-select2').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select2').getElementsByTagName('select')[0], jQuery('.selector-wrapper:eq(2) select'));
}
    
    
};
  
     function checkIfDisabled() {
         setTimeout(function () {
             var elem = jQuery('.crc-buyNow').eq(0);
             jQuery('.crc-st-item__button').html(elem.html());
             if (elem.html().toUpperCase() != 'BUY NOW') {
                 jQuery('.crc-st-item__button').html(elem.html());
                 jQuery('.crc-st-item__button').addClass('crc-st-disabled');
             } else {
                 jQuery('.crc-st-item__button').removeClass('crc-st-disabled');
             }
         }, 100);
     }
//checkIfDisabled();
  jQuery('.r > label').click(function(){
   		checkIfDisabled();
});
jQuery('#st-select0 > select').change(function(){
  checkIfDisabled();
  var i = jQuery(this).find(":selected").attr('id');
  jQuery('.selector-wrapper:eq(0) select').prop('selectedIndex', i).change();
 
});
jQuery('#st-select1 > select').change(function(){
    checkIfDisabled();
 var i = jQuery(this).find(":selected").attr('id');
   jQuery('.selector-wrapper:eq(1) select').prop('selectedIndex', i).change();
  
});
jQuery('#st-select2 > select').change(function(){
    checkIfDisabled();
 var i = jQuery(this).find(":selected").attr('id');
  jQuery('.swatch:eq(2) input').eq(i).click();
  
});
  
jQuery('.selector-wrapper:eq(0) select').change(function(){
checkIfDisabled();
 jQuery('#st-select0 > select').val(jQuery(this).val());
});
  
jQuery('.selector-wrapper:eq(1) select').change(function(){
 jQuery('#st-select1 > select').val(jQuery(this).val());
});
  
  jQuery('.selector-wrapper:eq(2) select').change(function(){
 jQuery('#st-select2 > select').val(jQuery(this).val());
});
    
    
  checkIfDisabled();
  
function isVisible(elem){
var elementTop = elem.offset().top;
var elementBottom = elementTop + elem.outerHeight();
var viewportTop = jQuery(window).scrollTop();
var viewportBottom = viewportTop + jQuery(window).height();
return elementBottom > viewportTop && elementTop < viewportBottom;
};
       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("crc-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('crc-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('crc-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery('.crc-buyNow').eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
                             
}


}             
   
   
}); 
}

